The formatted representation of the whole address for display purposes.
